import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { BroadcastService } from './broadcast.service';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ErrorResponse } from '../models/rest.model';
import { MessageEvent } from '../models/broadcast.model';
import { MessageSeverity } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorResponseInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private broadcastService: BroadcastService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (error: any) => {
      if (error instanceof HttpErrorResponse) {
        const httpErrorResponse = error as HttpErrorResponse;
        // Status 0 is a result of unsuccessful OPTIONS CORS preflight request.
        if ((error.status === 401 || error.status === 0) && (window.location.href.match(/\?/g) || []).length < 2) {
          console.log('The authentication session expired or the user is not authenticated. Force refresh of the current page.');

          // TODO Replace by a configured application root
          // if (this.router.url !== '/login') {
            // window.location.href = '/login';
            alert('Error');
            // }
        } else if (httpErrorResponse.error && httpErrorResponse.error.messages) {
          const errorResponse = httpErrorResponse.error as ErrorResponse;
          errorResponse.messages.forEach(errorMessage => {
            this.broadcastService.broadcast(
              new MessageEvent(
                MessageSeverity.ERROR,
                errorMessage.key));
          });
        } else {
          this.broadcastService.broadcast(
            new MessageEvent(
              MessageSeverity.ERROR,
              'app_error_internalServerError',
              [error.status])
          );
        }

        return throwError(error);
      }
    }));
  }
}
